import React from 'react';
import { useTranslation } from 'localization';
import type { FactorRosterMember } from '../../../../types/statusFactors';

/** VIA: one chip per provenance, stacked inside the fixed track; long labels truncate and keep a tooltip. */
const ViaCell: React.FC<{ member: FactorRosterMember }> = ({ member }) => {
  const { t } = useTranslation();
  const labelFor = (source: FactorRosterMember['sources'][number]): string => {
    if (source.kind === 'measure') {
      return t('statusFactors.roster.viaChip.measure', 'measures · {{measure}}', {
        measure: (source.measureSystemName ?? '').replaceAll('_', ' '),
      });
    }
    return t(`statusFactors.roster.viaChip.${source.kind}`, source.kind === 'rule' ? 'matches the rule' : 'always included');
  };

  // A server row can repeat a provenance; one chip per distinct (kind, measure) is the contract.
  const distinctSources = member.sources.filter(
    (source, index, all) =>
      all.findIndex((other) => other.kind === source.kind && other.measureSystemName === source.measureSystemName) === index
  );

  return (
    <span className="rollup-roster__via" data-testid="roster-cell-via">
      {distinctSources.map((source) => {
        const label = labelFor(source);
        return (
          <span
            key={`${source.kind}:${source.measureSystemName ?? ''}`}
            className="rollup-roster__via-chip"
            data-testid="roster-via-chip"
            title={label}
          >
            {label}
          </span>
        );
      })}
    </span>
  );
};

export default ViaCell;
